export class AdeRestoreEncryptionConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bekSecretUrl",
            "baseName": "bekSecretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "kekUrl",
            "baseName": "kekUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceVaultId",
            "baseName": "sourceVaultId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AdeRestoreEncryptionConfig.attributeTypeMap;
    }
    constructor() {
    }
}
